(function () {
    'use strict';

    function CustomerStatisticsV2ComponentController($scope, $state, CustomerCustom, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, $stateParams) {
        //
        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.customerStatisticsObject = {};
        $ctrl.customerStatisticsObject.totalReserveNumber = 0;

        loadPage();

        function loadPage() {
            translatePartialLoader.addPart('customerStatistics');

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();


        }


        $scope.$watch('$ctrl.selectedCustomerId', function () {
            if ($ctrl.selectedCustomerId) {
                loadCustomerStatistics();
            }
        })


        function loadCustomerStatistics() {
            $ctrl.customerStatisticsObject = CustomerCustom.getCustomerStatisticsV2($ctrl.selectedCustomerId).query();
            if (!$ctrl.customerStatisticsObject)
                $ctrl.customerStatisticsObject = {};

            if (!$ctrl.customerStatisticsObject.totalReserveNumber)
                $ctrl.customerStatisticsObject.totalReserveNumber = 0;

            if (!$ctrl.customerStatisticsObject.totalCanceledNumber)
                $ctrl.customerStatisticsObject.totalCanceledNumber = 0;


        }

    }

    var CustomerStatisticsV2Component = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/customer-statistics-v2/partial-form.customer-statistics-v2.html',
        controller: CustomerStatisticsV2ComponentController,
        bindings:
            {
                selectedCustomerId: '<',
            }

    };

    angular
        .module('tikonApp')
        .component('pfCustomerStatisticsV2', CustomerStatisticsV2Component)

    CustomerStatisticsV2ComponentController.$inject = ['$scope', '$state', 'CustomerCustom', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', '$stateParams'];


})();

